import { call, put, takeEvery } from 'redux-saga/effects';
import { getCapRegistration } from '../../../requests/cap_requests/get_cap_registration_request';
import { getLeadsCapRegistrationRequestSuccess, getLeadsCapRegistrationRequestFailure } from '../../actions/cap_actions/get_cap_registration.actions';
import { GET_LEADS_CAP_REGISTRATION_REQUEST } from '../../constants/cap.constants';
import { message_error } from '../../../../../../components/Message';

function* getCapRegistrationRequest({ derivative_introduced, derivative_discontinued }) {
    const { result, options, error } = yield call(getCapRegistration, derivative_introduced, derivative_discontinued);
    if (result) {
        yield put(getLeadsCapRegistrationRequestSuccess(options));
    } else {
        yield put(getLeadsCapRegistrationRequestFailure(error));
        message_error(error?.message);
    }
}

export default function* getCapRegistrationSaga() {
    yield takeEvery(GET_LEADS_CAP_REGISTRATION_REQUEST, getCapRegistrationRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/cap.sagas/get_cap_registration.saga.js